export const getEmptyItems = (args: Record<string, any>): string[] =>
    Object.keys(args).filter((key) => !args[key])
